import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { isPlatformBrowser } from '@angular/common';
import { FlashMessageService } from '../../shared/components/flash-message/flash-message.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private readonly isBrowser: boolean;

    constructor(
        @Inject(PLATFORM_ID) private readonly platformId: Object,
        private readonly authenticationService: AuthenticationService,
        private readonly flashMessage: FlashMessageService,
        private readonly translate: TranslateService,
        private readonly router: Router,
        private readonly loaderService: LoaderService
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {

                if (err.status === 401 && this.isBrowser) {
                    const currentUser = this.authenticationService.currentUserValue;

                    if (currentUser?.Token) {
                        const shouldShowMessage = this.authenticationService.logout();

                        if (shouldShowMessage) {
                            this.flashMessage.showErrorAlert(this.translate.instant("session_expired"));
                        }
                        this.loaderService.display(false);

                        // Manufacturer pages: stay on the current page.
                        if (this.isManufacturerPage()) {
                            return EMPTY;
                        }

                        // Normal authenticated pages: redirect to home.
                        this.router.navigate(['/home']);
                        return EMPTY;

                    }
                }
                return throwError(() => err);
            })
        );
    }

    private isManufacturerPage(): boolean {
        return this.router.url.toLowerCase().startsWith('/manufacturer');
    }
}
